import React from "react";
import { Typography } from "@material-ui/core";
import WalletMerchantView from "./WalletMerchantView";
import { blueGrey } from "@material-ui/core/colors";

export default function WalletExistenceOnBoardingView() {
    return (
        <div style={{
            backgroundColor: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 40,
        }}>

            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Typography style={{
                    color: 'black',
                    fontSize: 45,
                    fontWeight: 600,
                    textAlign: 'center'
                }}>Need a Bitcoin Wallet?</Typography>
                <img src={require('./../images/bitcoin_wallet.png')} />
            </div>
            <Typography style={{
                textAlign: 'center',
                color: blueGrey[200],
                fontSize: 18,
                paddingLeft: 30,
                paddingRight: 30,
            }}>
                You can Get a FREE Bitcoin Wallet from any of the following Bitcoin Exchanges
            </Typography>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                marginTop: 20,
                flexWrap: 'wrap'
            }}>
                <WalletMerchantView link={"https://www.luno.com"} title={"Luno"} imageSrc={require('./../images/luno.png')} />
                <WalletMerchantView link={"https://www.blockchain.com"} title={"BlockChain"} imageSrc={require('./../images/blockchain.png')} />
                <WalletMerchantView link={"https://www.coinbase.com"} title={"Coinbase"} imageSrc={require('./../images/coinbase.png')} />
            </div>
        </div>
    );
}